const VERTICAL = "vertical";

export { VERTICAL };
